module.exports = __webpack_public_path__ + "static/media/screenwhite.66798c60.png";